import * as React from 'react'
import styled from 'styled-components'
import { FormikConsumer } from 'formik'
import Input from 'web-makeup/dist/Input'
import myStorage from 'web-fns/dist/storage'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import { placeholderColor } from '../../style'

const InputWrapper = styled.div<{ color?: string }>`
  display: flex;

  ${({ color }) => {
    let style = ''
    if (color) {
      style = `.ant-btn-primary,
               .ant-btn-primary:hover {
                  border-color: ${color};
                  background: ${color};
                }`
    }
    return style
  }};
`

const StyledInput = styled(Input)<{ showTitleError?: boolean }>`
  &&& {
    border: 1px solid ${({ showTitleError }) => (showTitleError ? colors.alert : colors.radagast)};
    height: 2.75rem;
    font-size: 1rem;
    color: ${colors.black1};

    &:focus {
      border-color: ${colors.nebula};
      outline: none;
      box-shadow: none;
    }

    &.filled {
      background: ${colors.dust};
      border-color: ${colors.dust};
    }

    ${placeholderColor(colors.nebula)};
  }
`

const PURCHASE_CUSTOM_TITLE = 'PURCHASE_CUSTOM_TITLE'

interface Props {
  fieldName: string
  color?: string
  showTitleError?: boolean
  onChange?: () => void
}

const PurchaseTitle = ({
  fieldName,
  color,
  intl,
  showTitleError,
  onChange,
}: Props & InjectedIntlProps) => {
  const [isFilled, setIsFilled] = React.useState(false)
  return (
    <FormikConsumer>
      {formik => {
        return (
          <InputWrapper color={color}>
            <StyledInput
              showTitleError={showTitleError}
              className={isFilled ? `filled` : ``}
              placeholder={intl.formatMessage({ id: 'purchase.project.placeholder' })}
              onChange={val => {
                onChange && onChange()
                myStorage.setItem(PURCHASE_CUSTOM_TITLE, 'true')
                formik.setFieldValue(fieldName, val.target.value)
                formik.setFieldTouched(fieldName, true)
              }}
              onBlur={val => (val.target.value ? setIsFilled(true) : setIsFilled(false))}
            />
          </InputWrapper>
        )
      }}
    </FormikConsumer>
  )
}

export default injectIntl(PurchaseTitle)



// WEBPACK FOOTER //
// ./src/components/PurchaseTitle/PurchaseTitle.tsx